<template>
    <div class="contact-section" id="contact">
        <v-row id="contact" style="background-color:#111111;min-height:100vh">
            <v-col cols="1"></v-col>
            <v-col cols="10">
                <v-row>
                    <v-col cols="12">
                        <h2 style="text-align:left;color:rgba(255,255,255,0.1)!important;margin-bottom:-50px!important"
                            class="header-watermark">contact</h2>
                    </v-col>
                </v-row>

                <v-row>

                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="4" class="info-col-padding-2">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/contact.png" :strength="isMobile() ? 0 : 20"
                                style="width:80%;margin-left:0px" axis="x" type="depth" />

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20" axis="x"
                                style="margin-top:0px;color:#72d2f6">Craig Haworth</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                founder</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                <a href="mailto:craig.haworth@loomitech.co.za">craig.haworth@loomitech.co.za</a>
                            </KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                +27 (0)72 012 1187</KinesisElement>


                        </KinesisContainer>
                    </v-col>

                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="4" class="info-col-padding-2">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/company.png" :strength="isMobile() ? 0 : 20"
                                style="width:80%;margin-left:0px" type="depth" axis="x" />

                            <KinesisElement tag="h3" type="depth" axis="x" :strength="isMobile() ? 0 : 20"
                                style="margin-top:0px;color:#72d2f6">loomiToy PTY(Ltd)</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                <font style='font-family: "Walkway Black", Helvetica, Arial;'>t/a loomitech</font>
                            </KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                2016/306976/07</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                VAT Registered.</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                Import/Export Licenced.</KinesisElement>

                        </KinesisContainer>
                    </v-col>

                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="4" class="info-col-padding-2">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/address.png" :strength="isMobile() ? 0 : 20"
                                style="width:80%;margin-left:0px" type="depth" axis="x" />

                            <KinesisElement tag="h3" type="depth" axis="x" :strength="isMobile() ? 0 : 20"
                                style="margin-top:0px;color:#72d2f6">Head Office</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">8
                                Frere Street</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                Kensington B</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                Randburg</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                Gauteng</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                South Africa</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : -30" style="margin-top:0px;color:#eeeeee">
                                2194</KinesisElement>

                        </KinesisContainer>
                    </v-col>

                </v-row>
            </v-col>
            <v-col cols="1"></v-col>
        </v-row>
    </div>
</template>

<script>
import { KinesisContainer, KinesisElement } from 'vue-kinesis'

export default {
    components: {
        KinesisContainer,
        KinesisElement
    },
    data: () => ({
        carouselItem: 0,
        selectedPortfolio: null,
        showDialog: false,
        portfolio: [
            {
                files: [
                    '/img/easefica-1.png',
                    '/img/easefica-2.png',
                    '/img/easefica-3.png',
                    '/img/easefica-4.png',
                ]
            },
            {
                files: [
                    '/img/easefica-admin-1.png',
                    '/img/easefica-admin-2.png',
                    '/img/easefica-admin-3.png',
                    '/img/easefica-admin-4.png',
                ]
            },
            {
                files: [
                    '/img/loomiot-1.png',
                    '/img/loomiot-2.png',
                    '/img/loomiot-3.png',
                ]
            }
        ]
    }),
    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        selectPortfolio(p) {
            this.selectedPortfolio = p;
            this.carouselItem = 0;
            this.showDialog = true;
        },
        closePortfolio() {
            this.selectedPortfolio = null;
            this.carouselItem = 0;
            this.showDialog = false
        }
    }
}
</script>

<style scoped>
.watermark-black {
    font-size: 256px;
    font-family: "Walkway Black";
    font-weight: lighter;
    line-height: 280px;
    margin-top: 32px;
    color: rgba(255, 255, 255, 0.05);
    max-width: 100%;
    overflow: hidden;
}

.header-watermark {
    font-size: 256px;
    font-family: "Walkway Black";
    font-weight: lighter;
    line-height: 280px;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.05);
    margin-bottom: -100px;
    margin-top: 32px;
}

.carousel-view {
    height: 80vh;
    width: 80vw;
    border-radius: 5px;
    z-index: 100;
}

.close-button {

    background-color: white;
}

.portfolio-list {
    margin-top: 32px;
}

.portfolio-item {
    position: relative;
    margin-top: 120px;
    min-height: 50vh;
    cursor: pointer;
}

.web-section {
    position: relative;
    background-color: #111111;
    min-height: 100vh;
    width: auto;
    background: url('/img/bg2.jpg');
    background-size: cover
}

.web-heading {
    position: absolute;
    width: 100%;
    top: 0%
}

@media (max-width: 1020px) {
    .portfolio-item {
        position: relative;
        margin-top: 120px;
        min-height: 40vh;
        cursor: pointer;
    }

    .watermark-black {
    font-size: 256px;
    font-family: "Walkway Black";
    font-weight: lighter;
    line-height: 280px;
    margin-top: 32px;
    color: rgba(255, 255, 255, 0.05);
    max-width: 100%;
    overflow: hidden;
}

    .header-watermark {
        font-size: 200px;
        font-family: "Walkway Black";
        font-weight: lighter;
        line-height: 280px;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.05);
        margin-bottom: -100px;
        margin-top: 0px;
    }

    h3 {
        font-family: "Walkway Black", Helvetica, Arial;
        font-size: 32px;
        font-weight: lighter;
        line-height: 40px;
    }

    h4 {

        font-size: 20px;
        font-weight: lighter;
        line-height: 28px;
        margin-top: 8px;
        margin-bottom: 16px;
    }
}

@media (max-width: 600px) {
    .portfolio-item {
        position: relative;
        margin-top: 32px;
        min-height: 25vh;
        cursor: pointer;
    }

    .watermark-black {
    font-size: 128px;
    font-family: "Walkway Black";
    font-weight: lighter;
    line-height: 128px;
    margin-top: 32px;
    color: rgba(255, 255, 255, 0.05);
    max-width: 100%;
    overflow: hidden;
}
    .header-watermark {
        font-size: 128px;
        font-family: "Walkway Black";
        font-weight: lighter;
        line-height: 280px;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.05);
        margin-bottom: -100px;
        margin-top: 0px;
    }

    h3 {
        font-family: "Walkway Black", Helvetica, Arial;
        font-size: 32px;
        font-weight: lighter;
        line-height: 40px;
    }

    h4 {

        font-size: 20px;
        font-weight: lighter;
        line-height: 28px;
        margin-top: 8px;
        margin-bottom: 16px;
    }
}
</style>